// @ts-nocheck

import styled, { css } from 'styled-components';
import UIPagination from '../../../../components/ui/Pagination';

export const Pagination = styled(UIPagination).withConfig({ displayName: "styles__Pagination", componentId: "sc-1pxy4ep-0" })(["margin:16px;"]);


export const List = styled.ul.withConfig({ displayName: "styles__List", componentId: "sc-1pxy4ep-1" })(["display:flex;flex-direction:column;margin-top:8px;overflow-x:auto;height:100%;flex:1;"]);







export const Item = styled.li.withConfig({ displayName: "styles__Item", componentId: "sc-1pxy4ep-2" })(["padding:5px 16px;min-height:25px;box-sizing:border-box;display:flex;align-items:center;color:#3d4042;cursor:pointer;", ";:hover{background:#2770ffc9;color:white;}"],







(props) =>
props.active &&
css(["background:#2770ff;color:white;"]));








export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-1pxy4ep-3" })(["width:330px;background:white;border-top:1px solid #c0ccd7;border-right:1px solid #c0ccd7;display:flex;flex-direction:column;"]);







export const Header = styled.header.withConfig({ displayName: "styles__Header", componentId: "sc-1pxy4ep-4" })(["min-height:66px;border-bottom:1px solid #c0ccd7;display:flex;align-items:center;justify-content:space-between;padding:0 18px;"]);







export const HeaderSide = styled.div.withConfig({ displayName: "styles__HeaderSide", componentId: "sc-1pxy4ep-5" })(["width:50%;display:flex;", ""],


(props) =>
props.right &&
css(["justify-content:flex-end;"]));
